function init(img) {
  const picture = img.closest("picture");

  if (!picture) return;

  const fallback = () => {
    const source = picture.querySelector(`source[srcset='${img.currentSrc}']`);

    if (source) picture.removeChild(source);
  };

  img.onerror = fallback;

  if (img.complete && img.naturalWidth === 0)
    fallback();
}

export { init };
